export default "__VITE_ASSET__CRMai2Hw__"